import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
    // DO NOT set Content-Type here — let Axios set it automatically.
    // FormData uploads need multipart/form-data (with boundary), not application/json.
    timeout: 30000,
});

// Attach JWT token and active organization if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const activeOrgId = localStorage.getItem('active_org_id');
    if (activeOrgId) config.headers['X-Organization-Id'] = activeOrgId;
    return config;
});

// Normalize errors: convert FastAPI detail (string | array | object) to a readable string
api.interceptors.response.use(
    (res) => res,
    async (err) => {
        let detail = err.response?.data?.detail;
        
        // Handle Blob errors (when responseType: 'blob' is used but API returns JSON error)
        if (err.response?.data instanceof Blob && err.response.data.type === 'application/json') {
            try {
                const text = await err.response.data.text();
                const json = JSON.parse(text);
                detail = json.detail || detail;
            } catch (e) {
                // ignore parsing errors
            }
        }

        let message;
        if (!detail) {
            message = err.message || 'Unknown error';
        } else if (typeof detail === 'string') {
            message = detail;
        } else if (Array.isArray(detail)) {
            // FastAPI 422 validation: [{loc:[...], msg:"...", type:"..."}, ...]
            message = detail
                .map(d => `${Array.isArray(d.loc) ? d.loc.at(-1) : ''}: ${d.msg || JSON.stringify(d)}`.trim())
                .join(' | ');
        } else {
            message = JSON.stringify(detail);
        }
        return Promise.reject(new Error(message));
    },
);

export default api;
